import { useMutation, useQuery } from "@tanstack/react-query"
import userService from "services/user.service"
import type { TChangePassword } from "types/user.type"
import type { TUserRole } from "types/user.type"

export const useUserProfile = (enabled?: boolean) => {
	return useQuery({
		queryKey: ["userProfile"],
		queryFn: () => userService.getUserProfile(),
		select: ({ data }) => data,
		enabled: enabled,
	})
}

export const useUsers = () => {
	return useQuery({
		queryKey: ["users"],
		queryFn: () => userService.getUsers(),
		select: ({ data }) => data.users,
	})
}

export const useChangeUserRole = () => {
	return useMutation({
		mutationKey: ["changeUserRole"],
		mutationFn: ({ id, newRole }: TUserRole) => userService.changeUserRole(id, newRole),
	})
}

export const useInviteUser = () => {
	return useMutation({
		mutationKey: ["inviteUser"],
		mutationFn: () => userService.inviteUser(),
	})
}

export const useChangeUserStatus = () => {
	return useMutation({
		mutationKey: ["changeUserStatus"],
		mutationFn: ({ id, newStatus }: { id: number; newStatus: string }) => userService.changeUserStatus(id, newStatus),
	})
}

export const useChangePassword = () => {
	return useMutation({
		mutationKey: ["changePassword"],
		mutationFn: (data: TChangePassword) => userService.changePassword(data),
	})
}

export const useDeleteUser = () => {
	return useMutation({
		mutationKey: ["deleteUser"],
		mutationFn: ({ id, password }: { id: number; password: string }) => userService.deleteUser(id, password),
	})
}

export const useNatsCreds = () => {
	return useQuery({
		queryKey: ["natsCreds"],
		queryFn: () => userService.getNatsCreds(),
		select: ({ data }) => data,
	})
}
